import { useContext } from 'react'

import RailsEnvContext from '../contexts/RailsContext'

const useRailsEnv = () => useContext(RailsEnvContext)

export default useRailsEnv
